import styles from './index.module.scss';
import LeftHeader from '../Headers/LeftHeader';
import { DownloadIcon } from '@navi/web-ui/lib/icons';
import Typography from '@navi/web-ui/lib/primitives/Typography';
import { Button } from '@navi/web-ui/lib/primitives';
import SolidCrossIcon from '@cp/src/assets/images/icons/SolidCrossIcon';
import SolidCheckIcon from '@cp/src/assets/images/icons/SolidCheckIcon';
import ValidationsContainer from './DataValidationContainer';
import cx from 'classnames';
import { ValidationData } from '../../../interface';
import { RootState } from '@cp/src/store';
import { useSelector } from 'react-redux';
import { addClickstreamEvent } from '@cp/src/service/clickStreamEventService';

const MockAllocationValidationTable = ({
  title,
  onClick,
  data,
  clickstreamEvent
}: {
  title: string;
  onClick: () => void;
  data: ValidationData[];
  clickstreamEvent: { name: string; description: string };
}) => {
  const mockId = useSelector(
    (state: RootState) => state?.fieldAllocation?.fieldAllocationDetails?.allocationTrackerId
  );

  if (!data?.length) {
    return null;
  }

  const handleErrorReportClick = () => {
    if (clickstreamEvent) {
      addClickstreamEvent(clickstreamEvent, {
        mockId: mockId
      });
    }
    onClick();
  };

  return (
    <div className={cx('w-full', styles.containerBorder)}>
      <div className={styles.headerContainer}>
        <LeftHeader title={title} variant="h4" />
        <Button
          onClick={handleErrorReportClick}
          variant="text"
          className="text-center"
          startAdornment={
            <DownloadIcon width={16} height={16} color="var(--navi-color-blue-base)" />
          }
        >
          <Typography variant="h4" color="var(--navi-color-blue-base)">
            Error report
          </Typography>
        </Button>
      </div>
      <div className={styles.mockAllocationDetailsContainer}>
        {data?.map((item: ValidationData) => (
          <ValidationsContainer
            key={item?.key}
            validationName={item?.comments}
            validationIcon={item?.color === 'green' ? <SolidCheckIcon /> : <SolidCrossIcon />} //TODO: Remove color dependency
          />
        ))}
      </div>
    </div>
  );
};

export default MockAllocationValidationTable;
